import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => ({
        url: urls.roles,
      }),
    }),
    getExtPartnersRoles: builder.query({
      query: () => ({
        url: urls.extPartnersRoles,
      }),
    }),
    getExtUsersRoles: builder.query({
      query: () => ({
        url: urls.extUsersRoles,
      }),
    }),
    getRole: builder.query({
      query: (id) => ({
        url: urls.roleDetail(id),
      }),
    }),
    ldapSync: builder.mutation({
      query() {
        return {
          url: urls.ldapSynchronization,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useGetRolesQuery,
  useGetExtPartnersRolesQuery,
  useGetExtUsersRolesQuery,
  useGetRoleQuery,
} = rolesApi;
